import { Injectable } from '@angular/core';
import { Observable, from, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { domtoimage } from './dom-to-image';
import { MapDrawingStateService } from '@app/modules/cop/drawing/map-drawing-state.service';

@Injectable({ providedIn: 'root' })
export class ScreenshotService {
  constructor(private mapDrawingState: MapDrawingStateService) {}

  takeScreenshot(sourceElement: HTMLElement): Observable<string> {
    //default values
    let mapElementWidth: number = screen.width;
    let mapElementHeight: number = screen.height - 150;

    //top header bar and main cop elements to get width/height values
    const topo_header_bars = document.getElementsByTagName('topo-app-header');
    const app_cop_mains = document.getElementsByTagName('app-cop-main');

    let mapBounds: google.maps.LatLngBounds;

    //handle different resolutions, browser resizes, etc
    if (topo_header_bars && topo_header_bars.length > 0 && app_cop_mains && app_cop_mains.length > 0) {
      //adjust and get only the map width/height dimensions
      mapElementWidth = app_cop_mains[0]?.getBoundingClientRect()?.width || screen.width;
      mapElementHeight =
        (app_cop_mains[0]?.getBoundingClientRect()?.height || 0) - (topo_header_bars[0]?.getBoundingClientRect()?.height || 0);

      if (mapElementHeight <= 0) {
        mapElementHeight = screen.height;
      }

      mapBounds = this.mapDrawingState?.googleMap?.getBounds();
    }

    const options = {
      width: mapElementWidth,
      height: mapElementHeight,
      filter: (element: HTMLElement) => {
        if (element?.slot?.includes('hidden')) {
          return false;
        }

        if (element?.tagName === 'GMP-ADVANCED-MARKER') {
          const markerPosition = (element as HTMLElement & { position?: google.maps.LatLng | google.maps.LatLngLiteral | null })?.position;

          if (markerPosition && mapBounds) {
            const lat = typeof markerPosition.lat === 'function' ? markerPosition.lat() : markerPosition.lat;
            const lng = typeof markerPosition.lng === 'function' ? markerPosition.lng() : markerPosition.lng;

            const latLng = new google.maps.LatLng(lat, lng);
            const isInView = mapBounds.contains(latLng);

            return isInView;
          }
        }

        return true;
      }
    };

    return from(domtoimage.toPng(sourceElement, options));
  }
}
